<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="ip-question">
        <span class="ip-bar ip-bar--xl"></span>
      </div>
      <div class="ip-grid">
        <div class="ip-card">
          <svg viewBox="0 0 80 60" class="ip-img" preserveAspectRatio="none">
            <rect width="80" height="60" fill="#FFD6E7" />
            <circle
              cx="58"
              cy="18"
              r="9"
              fill="#FFB1C9"
            />
            <path d="M0 50 Q20 38 40 46 T80 42 L80 60 L0 60 Z" fill="#B12569" opacity="0.18" />
            <path d="M0 56 L80 56 L80 60 L0 60 Z" fill="#B12569" opacity="0.3" />
          </svg>
          <div class="ip-meta">
            <span class="ip-letter">A</span>
            <div class="ip-track">
              <div class="ip-fill ip-fill--a" style="--row-pct: 62%"></div>
            </div>
            <span class="ip-pct">62%</span>
          </div>
        </div>
        <div class="ip-card">
          <svg viewBox="0 0 80 60" class="ip-img" preserveAspectRatio="none">
            <rect width="80" height="60" fill="#D6E8FF" />
            <polygon points="20,40 35,20 50,32 65,15 65,50 20,50" fill="#B8D4FF" />
            <polygon points="20,40 35,20 50,32 50,50 20,50" fill="#2B5AA8" opacity="0.25" />
            <circle
              cx="22"
              cy="14"
              r="6"
              fill="#FFE680"
            />
          </svg>
          <div class="ip-meta">
            <span class="ip-letter">B</span>
            <div class="ip-track">
              <div class="ip-fill ip-fill--b" style="--row-pct: 38%"></div>
            </div>
            <span class="ip-pct">38%</span>
          </div>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="ip-phone-q"></span>
      <div class="ip-phone-grid">
        <button type="button" class="ip-phone-card --tapped" tabindex="-1">
          <svg viewBox="0 0 60 50" class="ip-phone-img" preserveAspectRatio="none">
            <rect width="60" height="50" fill="#FFD6E7" />
            <circle
              cx="44"
              cy="14"
              r="7"
              fill="#FFB1C9"
            />
            <path d="M0 42 Q15 32 30 38 T60 36 L60 50 L0 50 Z" fill="#B12569" opacity="0.2" />
          </svg>
          <span class="ip-phone-letter">A</span>
          <span class="material-symbols-rounded ip-phone-check">check</span>
        </button>
        <button type="button" class="ip-phone-card" tabindex="-1">
          <svg viewBox="0 0 60 50" class="ip-phone-img" preserveAspectRatio="none">
            <rect width="60" height="50" fill="#D6E8FF" />
            <polygon points="14,32 26,16 38,26 50,12 50,42 14,42" fill="#B8D4FF" />
          </svg>
          <span class="ip-phone-letter">B</span>
        </button>
      </div>
      <div class="ip-phone-hint">
        <span class="material-symbols-rounded">touch_app</span>
        Tap to vote
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewImagePair',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
})
</script>

<style scoped lang="scss">
.ip-bar {
  display: block; height: 8px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.2);
  width: 70%;
}
.ip-question {
  padding-bottom: 6px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}

.ip-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  flex: 1;
}
.ip-card {
  display: flex; flex-direction: column;
  gap: 5px;
}
.ip-img {
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 6px;
  display: block;
  border: 1px solid rgba(15, 15, 20, 0.08);
}
.ip-meta {
  display: grid;
  grid-template-columns: 16px 1fr auto;
  align-items: center;
  gap: 6px;
}
.ip-letter {
  width: 16px; height: 16px;
  border-radius: 999px;
  background: var(--accent); color: white;
  font-size: 9px; font-weight: 700;
  display: grid; place-items: center;
}
.ip-track {
  height: 8px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.06);
  overflow: hidden;
}
.ip-fill {
  height: 100%; width: 0;
  border-radius: 999px;
  background: var(--accent);
  animation: ip-grow 4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
.ip-fill--a { animation-delay: 0.7s; }
.ip-fill--b { animation-delay: 0.85s; }
.ip-pct {
  font-size: 10px; font-weight: 700;
  color: var(--accent);
  font-variant-numeric: tabular-nums;
  min-width: 26px; text-align: right;
}

/* ---- Audience phone ---- */
.ip-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.ip-phone-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}
.ip-phone-card {
  position: relative;
  appearance: none;
  padding: 0;
  border: 1.5px solid rgba(15, 15, 20, 0.1);
  border-radius: 6px;
  background: white;
  cursor: pointer;
  overflow: hidden;
  display: flex; flex-direction: column;
}
.ip-phone-img {
  width: 100%;
  aspect-ratio: 6 / 5;
  display: block;
}
.ip-phone-letter {
  position: absolute;
  bottom: 4px; left: 4px;
  background: rgba(15, 15, 20, 0.6);
  color: white;
  font-size: 9px; font-weight: 800;
  padding: 1px 5px;
  border-radius: 999px;
}
.ip-phone-card.--tapped {
  border-color: var(--accent);
  animation: ip-tap 4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
.ip-phone-check {
  position: absolute;
  top: 4px; right: 4px;
  background: var(--accent);
  color: white;
  font-size: 14px;
  border-radius: 999px;
  padding: 1px;
}
.ip-phone-hint {
  display: flex; align-items: center; justify-content: center;
  gap: 4px;
  font-size: 10px; font-weight: 700;
  color: var(--accent);
}
.ip-phone-hint .material-symbols-rounded { font-size: 14px; }

@keyframes ip-grow {
  0%, 12% { width: 0; }
  60%     { width: var(--row-pct, 50%); }
  92%, 100% { width: var(--row-pct, 50%); }
}
@keyframes ip-tap {
  0%, 4%   { box-shadow: 0 0 0 0 color-mix(in srgb, var(--accent) 35%, transparent); }
  18%      { box-shadow: 0 0 0 8px color-mix(in srgb, var(--accent) 0%, transparent); }
  100%     { box-shadow: 0 0 0 0 color-mix(in srgb, var(--accent) 0%, transparent); }
}

@media (prefers-reduced-motion: reduce) {
  .ip-fill { animation: none; width: var(--row-pct, 50%); }
  .ip-phone-card.--tapped { animation: none; }
}
</style>
